import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import DataObjectIcon from '@mui/icons-material/DataObject';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import SpeedIcon from '@mui/icons-material/Speed';
import UpdateIcon from '@mui/icons-material/Update';
import './AIProcess.css';

const processSteps = [
  {
    icon: <DataObjectIcon />,
    number: '01',
    title: 'Data Collection & Analysis',
    description: 'Gather and analyze relevant data to understand patterns and requirements.'
  },
  {
    icon: <PsychologyIcon />,
    number: '02',
    title: 'AI Strategy Planning',
    description: 'Design a comprehensive strategy tailored to your business objectives.'
  },
  {
    icon: <ModelTrainingIcon />,
    number: '03',
    title: 'Model Development',
    description: 'Build and train AI models using cutting-edge algorithms and techniques.'
  },
  {
    icon: <IntegrationInstructionsIcon />,
    number: '04',
    title: 'Integration & Testing',
    description: 'Seamlessly integrate AI solutions and ensure robust performance.'
  },
  {
    icon: <SpeedIcon />,
    number: '05',
    title: 'Deployment & Optimization',
    description: 'Deploy solutions and optimize for maximum efficiency and accuracy.'
  },
  {
    icon: <UpdateIcon />,
    number: '06',
    title: 'Continuous Improvement',
    description: 'Monitor, maintain, and enhance AI systems for optimal results.'
  }
];

const AIProcess = () => {
  return (
    <section className="ai-process">
      <div className="ai-process-bg-elements">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="ai-process-circuit-line" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${Math.random() * 100 + 50}px`,
            transform: `rotate(${Math.random() * 360}deg)`
          }}></div>
        ))}
      </div>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="ai-process-header"
        >
          <Typography variant="h2" className="ai-process-title">
            Our AI Development Process
          </Typography>
          <Typography variant="subtitle1" className="ai-process-subtitle">
            A systematic approach to implementing AI solutions
          </Typography>
        </motion.div>

        <div className="ai-process-timeline-container">
          <div className="ai-process-timeline-track">
            <div className="ai-process-progress-line"></div>
            <div className="ai-process-steps">
              {processSteps.map((step, index) => (
                <motion.div
                  key={index}
                  className="ai-process-step"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div className="ai-process-step-content">
                    <motion.div
                      className="ai-process-step-icon-wrapper"
                      whileHover={{ scale: 1.1 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      <div className="ai-process-step-icon">
                        {step.icon}
                      </div>
                      <div className="ai-process-step-number">{step.number}</div>
                    </motion.div>
                    <div className="ai-process-step-details">
                      <Typography variant="h6" className="ai-process-step-title">
                        {step.title}
                      </Typography>
                      <Typography variant="body2" className="ai-process-step-description">
                        {step.description}
                      </Typography>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AIProcess; 